import { useCallback, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import {
  SetSearchParamsOverride,
  useStateFromSearchParams,
} from './useStateFromSearchParams';

export const useDebouncedSearchStringQueryParams = (
  key: string,
  overrideSetSearchParams?: SetSearchParamsOverride
) => {
  const [nameSearchParam, _setNameSearchParam] = useStateFromSearchParams(
    key,
    '',
    overrideSetSearchParams
  );

  const [name, setNameState] = useState(nameSearchParam);
  const setNameSearchParam = useDebouncedCallback(_setNameSearchParam, 500);

  const setName = useCallback(
    (newName: string) => {
      setNameSearchParam(newName);
      setNameState(newName);
    },
    [setNameSearchParam]
  );

  return { name, setName, debouncedName: nameSearchParam };
};
